import Wrapper, { Triangle, Container } from './styles';
import React, { useEffect, useState } from 'react'
import { Name } from './styles';
import { Charge } from './styles';
import { Row } from './styles';
import { Td } from './styles';
import { Avatar } from './styles';
import { ButtonContainer } from './styles';
import { Button } from './styles';

const Tooltip = ({position, data}) => {
  const [image, setImage] = useState(false);

  useEffect(() => {
    const imageExists = (image_url) => {
      try{
        var http = new XMLHttpRequest();
        http.open('HEAD', image_url, false);
        http.send();
        return http.status != 404;
      }catch{
        return false;
      }
      
    }

    const url = `/imgs/${data.ID}.jpg`;

    if(imageExists(url)){
      setImage(url);
    }

  })

  return(
    <Wrapper style={{top: position[1] , left: position[0]}} special={position[1] < (window.innerHeight / 3)}>
      <Container>
        { 
          image && <Avatar style={{backgroundImage: `url(${image})`}} />
        }
        <Name>{data.name}</Name>
        <Charge>{data.charge}</Charge>
        <Row>
          <Td>
            <strong>Edad:</strong> {data.age}
          </Td>
          <Td>
            <strong>Defunción:</strong> {data.defunction_date}
          </Td>
        </Row>
        <Row>
          <Td>
            <strong>{data.hospital}</strong>
          </Td>
        </Row>
        <Row>
          <Td>
            Institución: <strong>{data.institution}</strong>
          </Td>
        </Row>
        <Row>
          <Td>
            <strong>{data.city}, {data.status}</strong>
          </Td>
        </Row>
        {
          data.url && data.url !== "Ninguno" && (
            <ButtonContainer>
              <Button>
                Da click en el círculo para ver el perfil
              </Button>
            </ButtonContainer>
          )
        }
      </Container>
      <Triangle />
    </Wrapper>
  )
}

export default Tooltip;